module.exports = "img/flags/WF.12bfd41.png";